import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TruckDetail from "../pages/trucks/TruckDetail";
import ManageTrucks from "../pages/trucks/ManageTrucks";
import Drivers from "../pages/drivers/page";
import TasksPage from "../pages/tasks/page";
import LoginPage from "../pages/login/page";
import ProfilePage from "../pages/profile/page";
import AuthGuard from "../components/feature/AuthGuard";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: <AuthGuard><Home /></AuthGuard>,
  },
  {
    path: "/trucks",
    element: <AuthGuard><ManageTrucks /></AuthGuard>,
  },
  {
    path: "/trucks/:id",
    element: <AuthGuard><TruckDetail /></AuthGuard>,
  },
  {
    path: "/drivers",
    element: <AuthGuard><Drivers /></AuthGuard>,
  },
  {
    path: "/tasks",
    element: <AuthGuard><TasksPage /></AuthGuard>,
  },
  {
    path: "/profile",
    element: <AuthGuard><ProfilePage /></AuthGuard>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;